import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, finalize, map, Observable, of, tap, throwError } from 'rxjs';
import { Role } from 'src/app/models/enums/Role.enum';
import { RoleService } from 'src/app/services/api/role.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SharedService } from 'src/app/services/shared.service';


@Injectable({
  providedIn: 'root'
})
export class IsNotUserStoreGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private sharedService: SharedService,
    private loaderService: LoaderService,
    private roleService: RoleService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Controllo se il ruolo è stato già settato per evitare di invocare più volte l'API
    if (this.authService.user?.role) {
      //In questo caso ho il ruolo settato, emitto true per sbloccare la rotta
      return this.checkNotStoreUserAndSetDefaultStore(state.url)
    }
    //In questo caso non ho il ruolo, provedo ad invocare l'API per ottenerlo
    this.loaderService.show();
    return this.roleService.getRole()
      .pipe(
        tap((userConf) => {
          this.authService.setUserRole(userConf);
          return this.checkNotStoreUserAndSetDefaultStore(state.url);
        }),
        // delay(1000),
        catchError((e) => {
          this.sharedService.navigateTo_ErrorPage(() => console.log('error_page'));
          return of(e);
        }),
        finalize(() => this.loaderService.hide())
      );
  }

  checkNotStoreUserAndSetDefaultStore(currentUrl: string): boolean {
    if (this.authService.user?.isNotUserStore) {
      //Rimuovo lo store casomani l'utenza precedente aveva uno store settato
      this.authService.removeStore();
      let pathname = window.location.pathname;
      if (currentUrl !== pathname) {
        this.router.navigateByUrl(pathname);
      } else {
        this.sharedService.navigateTo_MainPage();
      }
      return false;
    }
    return true;
  }
}
